/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs */

const en__field__enum_teachingsubjects_subject_philosophy18 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophy`)
};

const de__field__enum_teachingsubjects_subject_philosophy18 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie`)
};

/**
* | output |
* | --- |
* | "Philosophy" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_philosophy18 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Philosophy18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_philosophy18(inputs)
	return de__field__enum_teachingsubjects_subject_philosophy18(inputs)
});
export { _field__enum_teachingsubjects_subject_philosophy18 as "_field__enum_teachingSubjects_SUBJECT_PHILOSOPHY" }